import { fromArray } from '../generators/entityGenerator';

export const PLANE = 'PLANE';
export const TRAIN = 'TRAIN';

const defaultTransportTypeOptions = [
  [PLANE],
  [PLANE],
  [PLANE],
  [PLANE],
  [PLANE, TRAIN],
  [TRAIN],
  [TRAIN],
  [TRAIN],
  [TRAIN],
  [TRAIN, PLANE],
  [PLANE],
  [PLANE],
  [TRAIN],
  [TRAIN],
];

const defaultTransportTypeLiteralOptions = [PLANE, TRAIN];

export const transportTypeGenerator = (options) =>
  fromArray(options || defaultTransportTypeOptions);

export const transportTypeLiteralGenerator = (options) =>
  fromArray(options || defaultTransportTypeLiteralOptions);
